module.exports = __webpack_public_path__ + "static/logo-5e111c66438a26a74d8bb63b78d3ecb3.jpg";